import { Chip, Typography } from '@mui/material'
import './labelChip.scss'

type LabelChipProps = {
  label: string;
  value: string;
}

const LabelChip = ({ label, value }: LabelChipProps) => (
  <div className="label-chip">
    <Typography
      fontWeight={700}
      fontSize={16}
      variant="body1">
      {label}
    </Typography>
    <Chip
      label={value}
      color="primary"
      variant="outlined" />
  </div>
)

export default LabelChip
